import React from 'react';
import QuantumLoader from './QuantumLoader';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  label?: string;
}

const sizeMap = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
};

export const LoadingSpinner = ({
  size = 'md',
  className = '',
  label,
}: LoadingSpinnerProps) => (
  <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
    <QuantumLoader startAngle={55} size={sizeMap[size]} />
    {label && (
      <p className="text-grey-600 dark:text-text-secondary text-sm">{label}</p>
    )}
  </div>
);

interface FullPageLoadingProps {
  label?: string;
}

export const FullPageLoading = ({ label = 'Loading...' }: FullPageLoadingProps) => (
  <div className="min-h-screen flex items-center justify-center bg-grey-50 dark:bg-background">
    <LoadingSpinner size="xl" label={label} />
  </div>
);

interface InlineLoadingProps {
  className?: string;
}

export const InlineLoading = ({ className = '' }: InlineLoadingProps) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <LoadingSpinner size="sm" />
    <span className="text-grey-500 dark:text-text-tertiary text-sm">Loading...</span>
  </div>
);

export default LoadingSpinner;
